/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteRemoteMcpServerHeaderSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteRemoteMcpServerHeaderSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteRemoteMcpServerHeaderSecurity = {
  option1?: DeleteRemoteMcpServerHeaderSecurityOption1 | undefined;
  option2?: DeleteRemoteMcpServerHeaderSecurityOption2 | undefined;
};

export type DeleteRemoteMcpServerHeaderRequest = {
  /**
   * The ID of the header to delete
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteRemoteMcpServerHeaderSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteRemoteMcpServerHeaderSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DeleteRemoteMcpServerHeaderSecurityOption1$Outbound,
    DeleteRemoteMcpServerHeaderSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteRemoteMcpServerHeaderSecurityOption1ToJSON(
  deleteRemoteMcpServerHeaderSecurityOption1:
    DeleteRemoteMcpServerHeaderSecurityOption1,
): string {
  return JSON.stringify(
    DeleteRemoteMcpServerHeaderSecurityOption1$outboundSchema.parse(
      deleteRemoteMcpServerHeaderSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteRemoteMcpServerHeaderSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteRemoteMcpServerHeaderSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DeleteRemoteMcpServerHeaderSecurityOption2$Outbound,
    DeleteRemoteMcpServerHeaderSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function deleteRemoteMcpServerHeaderSecurityOption2ToJSON(
  deleteRemoteMcpServerHeaderSecurityOption2:
    DeleteRemoteMcpServerHeaderSecurityOption2,
): string {
  return JSON.stringify(
    DeleteRemoteMcpServerHeaderSecurityOption2$outboundSchema.parse(
      deleteRemoteMcpServerHeaderSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteRemoteMcpServerHeaderSecurity$Outbound = {
  Option1?: DeleteRemoteMcpServerHeaderSecurityOption1$Outbound | undefined;
  Option2?: DeleteRemoteMcpServerHeaderSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteRemoteMcpServerHeaderSecurity$outboundSchema: z.ZodMiniType<
  DeleteRemoteMcpServerHeaderSecurity$Outbound,
  DeleteRemoteMcpServerHeaderSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteRemoteMcpServerHeaderSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteRemoteMcpServerHeaderSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteRemoteMcpServerHeaderSecurityToJSON(
  deleteRemoteMcpServerHeaderSecurity: DeleteRemoteMcpServerHeaderSecurity,
): string {
  return JSON.stringify(
    DeleteRemoteMcpServerHeaderSecurity$outboundSchema.parse(
      deleteRemoteMcpServerHeaderSecurity,
    ),
  );
}

/** @internal */
export type DeleteRemoteMcpServerHeaderRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteRemoteMcpServerHeaderRequest$outboundSchema: z.ZodMiniType<
  DeleteRemoteMcpServerHeaderRequest$Outbound,
  DeleteRemoteMcpServerHeaderRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteRemoteMcpServerHeaderRequestToJSON(
  deleteRemoteMcpServerHeaderRequest: DeleteRemoteMcpServerHeaderRequest,
): string {
  return JSON.stringify(
    DeleteRemoteMcpServerHeaderRequest$outboundSchema.parse(
      deleteRemoteMcpServerHeaderRequest,
    ),
  );
}
